import { useCallback } from "react";
import { useVisitorInfo } from "@/common/hooks";
import "./ExploreNicheNavigation.scss";
import { IItemList, Select } from "@/components/core/Select";
import { onOpenCreateNichePopup } from "@/components/popup-dispatcher/PopupDispatcher";
import { Button } from "@/components/buttons/Button";
import { useNicheOrdering } from "./hooks/useNicheOrdering";
import { SORT_OPTIONS, SORT_NAME_OPTIONS } from "./constants";

interface IProps {
  nameSuborder?: boolean;
  sortOptions?: IItemList[];
  onChange: (value: string) => void;
  order: string;
}

export const ExploreNicheNavigation = ({ order, onChange, sortOptions, nameSuborder }: IProps) => {
  const { handleChangeOrder } = useNicheOrdering({ nameSuborder, onOrderChanged: onChange });
  const currentUser = useVisitorInfo();

  const onClickCreateNiche = useCallback(() => {
    onOpenCreateNichePopup();
  }, []);

  const sortList = sortOptions || SORT_OPTIONS;
  const isNameOrderSelected = SORT_NAME_OPTIONS.some(item => item.value === order);
  const mainSelectValue = isNameOrderSelected ? "name" : order;

  return (
    <div className="nicheTopNav">
      <Select
        label="Sort by"
        value={mainSelectValue}
        list={sortList}
        onChange={handleChangeOrder}
      />

      {nameSuborder && isNameOrderSelected && (
        <Select
          value={order}
          list={SORT_NAME_OPTIONS}
          onChange={handleChangeOrder}
        />
      )}

      {currentUser && (
        <div className="nicheCreateBtn">
          <Button variant="secondary" size="xs" onClick={onClickCreateNiche}>Create Niche</Button>
        </div>
      )}
    </div>
  );
};
